// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { stripTags } from '../utils/helpers';
function Truncate(_ref) {
  var children = _ref.children,
    limit = _ref.limit;
  var truncatedStr = stripTags(children).slice(0, limit).trim();
  if (children.length > truncatedStr.length) {
    truncatedStr += '...';
  }
  return truncatedStr;
}
Truncate.propTypes = {
  children: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired
};
export default Truncate;